module.exports = __webpack_public_path__ + "3263b26ce8ddf6e75cfcf60c002eac65.png";